import { formatDate } from "@angular/common";
import { filter } from "rxjs/operators";
import { UserDetailsService } from "./../../../service/userdetails/user-details.service";
import { identifierModuleUrl } from "@angular/compiler";
import { Component, OnInit } from "@angular/core";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import * as moment from "moment";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";

import * as XLSX from "xlsx";
import {
  CapSMSMailService,
  RequestType,
} from "../../../service/capsmsmail/cap-smsmail.service";
import { AppConstants } from "../../../constants/app-constants";
import { DateutilService } from "./../../../service/dateutil/dateutil.service";
import { AwsAppServiceProvider } from "../../../providers/appsyncservice/ca.aws.notification.services";

export interface pushNotification {
  token?: string;
  notification?: {
    title?: string;
    body?: string;
  };
  android: {
    notification: {
      click_action: string;
    };
  };
  apns: {
    headers: {
      "apns-priority": string;
    };
    payload: {
      aps: {
        category: string;
      };
    };
  };
  data?: {
    icon: string;
    navigationTo: string;
    content: string;
    did: string;
    cp_header: string;
    request_id?: string;
  };
}

@Component({
  selector: "app-driver-concerns",
  templateUrl: "./driver-concerns.component.html",
  styleUrls: ["./driver-concerns.component.css"],
})
export class DriverConcernsComponent implements OnInit {
  displayConcernValue = 0;
  driverConcernList: any = [];
  errorMsg: string = "Loading... Please wait...";
  displayConcernItem: any;
  driverDetails: any = {};
  userDetails: any = {};
  driverConcernForm: FormGroup;
  driverMainModalBox: any = [];
  driverFeedBackBox: any = [];
  status: any = [
    { id: 2, name: "ACKNOWLEDGED" },
    { id: 3, name: "REJECTED" },
    { id: 4, name: "IN_PROGRESS" },
    { id: 5, name: "COMPLETED" },
  ];
  noOfItems = 10;
  setDateToGo: any;
  snoFilterModel: any = new Array();
  createdTypeFilterModel: any = new Array();
  TicketIdFilterModel: any = new Array();
  usernameFilterModel: any = new Array();
  nameFilterModel: any = new Array();
  driverUsernameFilterModel: any = new Array();
  driverNameFilterModel: any = new Array();
  concenTypeFilterModel: any = new Array();
  requestIdFilterModel: any = new Array();
  requestStatusFilterModel: any = new Array();
  slaTimingFilterModel: any = new Array();
  ageFilterModel: any = new Array();
  createdDateFilterModel: any = new Array();

  snoFilterData: any = [];
  createdTypeFilterData: any = [];
  TicketIdFilterData: any = [];
  usernameFilterData: any = [];
  nameFilterData: any[];
  driverUsernameFilterData: any = [];
  driverNameFilterData: any[];
  concenTypeFilterData: any[] = [];
  requestIdFilterData: any[];
  requestStatusFilterData: any[];
  slaTimingFilterData: any[];
  ageFilterData: any[];
  createdDateFilterData: any[];

  dropdownSettings = {
    sno: {
      singleSelection: false,
      idField: "sno",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search S.No.",
    },
    createType: {
      singleSelection: false,
      idField: "createType",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search createType.",
    },
    ticketId: {
      singleSelection: false,
      idField: "ticketId",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search ticket id.",
    },
    username: {
      singleSelection: false,
      idField: "username",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN No.",
    },
    name: {
      singleSelection: false,
      idField: "name",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      searchPlaceholderText: "Search Name",
    },
    driver_username: {
      singleSelection: false,
      idField: "driver_username",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      searchPlaceholderText: "Search No.",
    },
    driver_display_name: {
      singleSelection: false,
      idField: "driver_display_name",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      searchPlaceholderText: "Search Name",
    },
    concern_type: {
      singleSelection: false,
      idField: "concern_type",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Concern Type",
    },
    request_id: {
      singleSelection: false,
      idField: "request_id",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Request ID",
    },
    request_status: {
      singleSelection: false,
      idField: "request_status",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Request Status",
    },
    sla_timing: {
      singleSelection: false,
      idField: "sla_timing",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search SLA",
    },
    age: {
      singleSelection: false,
      idField: "age",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Age",
    },
    created_date: {
      singleSelection: false,
      idField: "created_date",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Date",
    },
  };

  that: any;

  sortKey: string = "sno"; //set default
  sortReverse: boolean = false;

  slaNextWorkingDay: any;
  minDate: any;
  constructor(
    private aws: AwsService,
    private formBuilder: FormBuilder,
    private userDetailservice: UserDetailsService,
    private capSmsMail: CapSMSMailService,
    private dateUtil: DateutilService,
    private pushNotificationService: AwsAppServiceProvider
  ) {
    this.getDriverConcernList();
    this.that = this;
    this.selectDateMinTime();
  }
  ngOnInit() { }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    console.log("ngAfterViewInit", "called...");
  }
  selectDateMinTime() {
    var todayDate = new Date();
    var month =
      (todayDate.getMonth() + 1 < 10 ? "0" : "") + (todayDate.getMonth() + 1);
    var day = (todayDate.getDate() < 10 ? "0" : "") + todayDate.getDate();
    var year = todayDate.getFullYear();
    this.minDate = year + "-" + month + "-" + day;
  }
  onItemSelect(event) {
    console.log("onItemSelect", event);
    return false;
  }
  onSelectAll(event) {
    console.log("onSelectAll", event);
  }
  getDriverConcernList() {
    this.driverConcernList = [];
    this.aws
      .getDriverConcernList()
      .then((res) => {
        console.log("getDriverConcernList", res);
        if (res.length > 0) {
          this.setDriverConcernList(res);
          // this.driverConcernList = res;
        } else {
          this.errorMsg = "Sorry!. No Concern is found.";
        }
      })
      .catch((err) => {
        console.error("getDriverConcernList", err);
        this.errorMsg = "Sorry!. Something went wrong! Try again!";
      });
  }

  private async setDriverConcernList(res) {
    var list = [];
    this.driverConcernList = [];
    for (var rs in res) {
      var rsdata = res[rs];
      res[rs].created_type = res[rs].created_type;
      res[rs].ticket_id = res[rs].ticket_id;
      list[rs] = rsdata;
      list[rs] = rsdata;
      //list[rs].sno=+rs+1;
      if (
        list[rs].request_status == "CANCELLED" ||
        list[rs].request_status == "REJECTED" ||
        list[rs].request_status == "COMPLETED"
      ) {
        var f = moment(list[rs].created_date);
        var s = moment(list[rs].comments[list[rs].comments.length - 1].date);
        list[rs].age = f.from(s, true);
        list[rs].ageSort = f.diff(s, "seconds");
      } else {
        list[rs].age = moment(list[rs].created_date).fromNow(false);
        list[rs].ageSort = moment().diff(
          moment(list[rs].created_date),
          "seconds"
        );
      }

      var name;
      if (rsdata.user_display_name == undefined) {
        var val = await this.userDetailservice.getDetails(rsdata.username);
        name = val.name;
      } else {
        name = rsdata.user_display_name;
      }

      list[rs].name = name;
      list[rs].driver_username =
        rsdata.driver_username == undefined ? "-" : rsdata.driver_username;
      list[rs].driver_display_name =
        rsdata.driver_display_name == undefined
          ? "-"
          : rsdata.driver_display_name;
      list[rs].request_statusSort =
        AppConstants.REQUEST_STATUS[list[rs].request_status];
      list[rs].request_statusColor =
        list[rs].request_status == "NEW_REQUEST"
          ? AppConstants.StatusColor.ORANGE
          : list[rs].request_status == "ACKNOWLEDGED" ||
            list[rs].request_status == "IN_PROGRESS"
            ? AppConstants.StatusColor.GREEN
            : "";

      list[rs].sla_timing = "-";
      list[rs].sla_timing_color = "";

      if (list[rs].request_status == "NEW_REQUEST") {
        var newReq = this.dateUtil.getNumberOfWorkingDays(
          new Date(),
          new Date(list[rs].created_date)
        );
        console.log(
          "newReq",
          newReq,
          newReq < -1,
          new Date(),
          new Date(list[rs].created_date)
        );
        if (newReq < -1) {
          list[rs].sla_timing = newReq * -1 + " working days is elapsed";
          list[rs].sla_timing_color = AppConstants.StatusCssClass.ELAPSED;
          list[rs].request_statusSort = newReq;
        } else {
          list[rs].sla_timing = "1 working day is remaining";
        }
      } else if (
        list[rs].request_status == "ACKNOWLEDGED" ||
        list[rs].request_status == "IN_PROGRESS"
      ) {
        if (list[rs].sla_date != null) {
          var ackInpro = this.dateUtil.getNumberOfWorkingDays(
            new Date(),
            new Date(list[rs].sla_date)
          );
          console.log("ackInpro", ackInpro);
          if (ackInpro > 0)
            list[rs].sla_timing = ackInpro + " working days is remaining";
          if (ackInpro < 0) {
            list[rs].sla_timing = ackInpro * -1 + " working days is elapsed";
            list[rs].sla_timing_color = AppConstants.StatusCssClass.ELAPSED;
            list[rs].request_statusSort = ackInpro;
          }
        }
      }

      // >>> MINIMAL FIX: normalize concern_type ONCE (avoid character split later)
      if (!Array.isArray(list[rs].concern_type)) {
        list[rs].concern_type =
          typeof list[rs].concern_type === "string"
            ? list[rs].concern_type
              .split(",")
              .map(v => v.trim())
              .filter(v => v.length > 0)
            : [];
      }
    }

    list = list.sort((a, b) => {
      if (a.request_statusSort < b.request_statusSort) {
        return -1;
      } else if (a.request_statusSort > b.request_statusSort) {
        return 1;
      } else if (a.request_statusSort == b.request_statusSort) {
        var adate = new Date(a.created_date);
        var bdate = new Date(b.created_date);

        if (a.sla_timing == "-" && b.sla_timing == "-") {
          if (adate.getTime() > bdate.getTime()) {
            return -1;
          } else if (adate.getTime() < bdate.getTime()) {
            return 1;
          }
        } else {
          if (adate.getTime() > bdate.getTime()) {
            return 1;
          } else if (adate.getTime() < bdate.getTime()) {
            return -1;
          }
        }

        return 0;
      }
      return 0;
    });
    list = this.addSno(list);

    this.driverConcernList = list;

    this.constructDropDownData(this, list, true);
    //  this.constructDropDownData(this,list,false);
  }

  private addSno(list: any[]): any[] {
    var ls: any[] = [];
    for (var rs in list) {
      var rsdata = list[rs];
      ls[rs] = rsdata;
      ls[rs].sno = +rs + 1;
    }
    return ls;
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return "fa fa-sort-desc";
      } else {
        return "fa fa-sort-asc";
      }
    } else {
      return "fa fa-sort";
    }
  }

  filterSearch(th, items, filter) {
    let result = items.filter((val) => {
      // ensure normalization for any legacy entries
      if (!Array.isArray(val.concern_type)) {
        val.concern_type =
          typeof val.concern_type === "string"
            ? val.concern_type
              .split(",")
              .map(v => v.trim())
              .filter(v => v.length > 0)
            : [];
      }

      if (
        filter.sno.length == 0 &&
        filter.username.length == 0 &&
        filter.name.length == 0 &&
        filter.driver_username.length == 0 &&
        filter.driver_display_name.length == 0 &&
        filter.concern_type.length == 0 &&
        filter.request_id.length == 0 &&
        filter.request_status.length == 0 &&
        filter.sla_timing.length == 0 &&
        filter.age.length == 0 &&
        filter.created_date.length == 0
      ) {
        return true;
      } else {
        const concernArray = val.concern_type; // already array
        var concernFound = concernArray.filter((v) => {
          return filter.concern_type.indexOf(v) >= 0;
        });
        // if(filter.sno.indexOf(""+val.sno)>=0 && filter.username.indexOf(val.username)>=0 && filter.name.indexOf(val.name)>=0 && concernFound.length>0 && filter.request_id.indexOf(val.request_id)>=0 && filter.request_status.indexOf(val.request_status)>=0 && filter.created_date.indexOf(formatDate(val.created_date,'MMM dd, yyyy','en'))>=0)
        return (
          (filter.sno.length > 0
            ? filter.sno.indexOf("" + val.sno) >= 0
            : true) &&
          (filter.username.length > 0
            ? filter.username.indexOf(val.username) >= 0
            : true) &&
          (filter.name.length > 0
            ? filter.name.indexOf(val.name) >= 0
            : true) &&
          (filter.driver_username.length > 0
            ? filter.driver_username.indexOf(val.driver_username) >= 0
            : true) &&
          (filter.driver_display_name.length > 0
            ? filter.driver_display_name.indexOf(val.driver_display_name) >= 0
            : true) &&
          (filter.concern_type.length > 0 ? concernFound.length > 0 : true) &&
          (filter.request_id.length > 0
            ? filter.request_id.indexOf(val.request_id) >= 0
            : true) &&
          (filter.age.length > 0 ? filter.age.indexOf(val.age) >= 0 : true) &&
          (filter.request_status.length > 0
            ? filter.request_status.indexOf(val.request_status) >= 0
            : true) &&
          (filter.sla_timing.length > 0
            ? filter.sla_timing.indexOf(val.sla_timing) >= 0
            : true) &&
          (filter.created_date.length > 0
            ? filter.created_date.indexOf(
              formatDate(val.created_date, "MMM dd, yyyy", "en")
            ) >= 0
            : true)
        );
      }
    });

    th.constructDropDownData(th, result, false);

    return result;
  }

  constructDropDownData(th, items, isData) {
    //  console.log("constructDropDownData",th.usernameFilterData);
    var snoData = [];
    var createdTypeData = [];
    var ticketIdData = [];
    var usernameData = [];
    var nameData = [];
    var driverUsernameData = [];
    var driverNameData = [];
    var concenTypeData = [];
    var requestIdData = [];
    var requestStatusData = [];
    var ageData = [];
    var slaTimingData = [];
    var createdDateData = [];

    for (var item of items) {
      console.log("username", item.sno, snoData.indexOf(item.sno));
      if (snoData.indexOf(item.sno) == -1) snoData.push("" + item.sno);
      if (createdTypeData.indexOf(item.created_type) == -1)
        createdTypeData.push("" + item.created_type);
      if (ticketIdData.indexOf(item.ticket_id) == -1)
        ticketIdData.push("" + item.ticket_id);
      if (usernameData.indexOf(item.username) == -1)
        usernameData.push(item.username);
      if (nameData.indexOf(item.name) == -1) nameData.push(item.name);
      if (driverUsernameData.indexOf(item.driver_username) == -1)
        driverUsernameData.push(item.driver_username);
      if (driverNameData.indexOf(item.driver_display_name) == -1)
        driverNameData.push(item.driver_display_name);
      concenTypeData = [...concenTypeData, ...item.concern_type];
      if (requestIdData.indexOf(item.request_id) == -1)
        requestIdData.push(item.request_id);
      if (ageData.indexOf(item.age) == -1) ageData.push(item.age);
      if (requestStatusData.indexOf(item.request_status) == -1)
        requestStatusData.push(item.request_status);
      if (slaTimingData.indexOf(item.sla_timing) == -1)
        slaTimingData.push(item.sla_timing);
      if (
        createdDateData.indexOf(
          formatDate(item.created_date, "MMM dd, yyyy", "en")
        ) == -1
      )
        createdDateData.push(
          formatDate(item.created_date, "MMM dd, yyyy", "en")
        );
    }

    console.log("constructDropDownData-", usernameData);
    if (isData) {
      th.snoFilterData = snoData;
      th.createTypeFilterData = createdTypeData;
      th.TicketIdFilterData = ticketIdData;
      th.usernameFilterData = usernameData;
      th.nameFilterData = nameData;
      th.driverUsernameFilterData = driverUsernameData;
      th.driverNameFilterData = driverNameData;
      th.concenTypeFilterData = concenTypeData.filter(
        (item, index) => concenTypeData.indexOf(item) === index
      );
      th.requestIdFilterData = requestIdData;
      th.requestStatusFilterData = requestStatusData;
      th.slaTimingFilterData = slaTimingData;
      this.ageFilterData = ageData;
      th.createdDateFilterData = createdDateData;
    } else {
      setTimeout(() => {
        /*   th.snoFilterModel=snoData
     th.usernameFilterModel=usernameData;
      th.nameFilterModel=nameData;
      th.concenTypeFilterModel=concenTypeData.filter((item,index) => concenTypeData.indexOf(item) === index)
      th.requestIdFilterModel=requestIdData
      th.requestStatusFilterModel=requestStatusData
      th.createdDateFilterModel=createdDateData */

        th.snoFilterData = snoData;
        th.createTypeFilterData = createdTypeData;
        th.TicketIdFilterData = ticketIdData;
        th.usernameFilterData = usernameData;
        th.nameFilterData = nameData;
        th.driverUsernameFilterData = driverUsernameData;
        th.driverNameFilterData = driverNameData;
        th.concenTypeFilterData = concenTypeData.filter(
          (item, index) => concenTypeData.indexOf(item) === index
        );
        th.requestIdFilterData = requestIdData;
        th.requestStatusFilterData = requestStatusData;
        th.slaTimingFilterData = slaTimingData;
        this.ageFilterData = ageData;
        th.createdDateFilterData = createdDateData;
      }, 0);
    }
  }

  setDriverConcernDetail(item) {
    this.displayConcernValue = 1;
    this.displayConcernItem = item;
    this.slaNextWorkingDay = "";
    this.aws
      .rnUserFilterById(item.driver_id)
      .then((res) => {
        console.log("rnUserFilterById" + item.driver_id, res);

        this.driverDetails = res[0];
      })
      .catch((err) => {
        console.log("rnUserFilterById", err);
      });
    this.aws.rnUserFilter(item.username).then((res) => {
      console.log("rnUserFilter", res);
      if (res.length > 0) {
        this.userDetails = res[0];
      }
    });

    this.formInitilization(item.id);
  }

  exportToExcel() {
    let exportJsonTemp = [];

    exportJsonTemp = this.excelDataFormation(this.driverConcernList);
    const workBook = XLSX.utils.book_new(); // create a new blank book

    const workSheet = XLSX.utils.json_to_sheet(exportJsonTemp);

    // ////console.log("EXCEL", exportJsonTemp);
    XLSX.utils.book_append_sheet(workBook, workSheet, "data"); // add the worksheet to the book
    XLSX.utils.book_append_sheet(workBook, {}, "consolidate"); // add the worksheet to the book

    XLSX.writeFile(
      workBook,
      "Driver Concerns-" + new Date().getTime() + ".xlsx"
    );
  }

  excelDataFormation(list) {
    let dateFormat = require("dateformat");
    var otlist = [];
    for (var l of list) {
      var r = {
        Sno: l.sno,
        "Request ID": l.request_id,
        "Request Status": l.request_status,
        "Ticket Age": l.age,
        "User name": l.username,
        Name: l.name,
        "Driver No.": l.driver_username,
        "Driver Name": l.driver_display_name,
        "Concern Types": Array.isArray(l.concern_type)
          ? l.concern_type.reduce((a, b) => a + "," + b)
          : l.concern_type || "",
        "Concern Description": l.user_text,
        SLA: l.sla_timing,
        "Feedback Status": l.satisfaction == 0 ? "" : l.satisfaction,
        "Feedback Description": l.feedback == 0 ? "" : l.feedback,
        "Request Date": dateFormat(l.created_date, "yyyy-mm-dd HH:MM:ss"),
        "Updated Date": dateFormat(l.updated_date, "yyyy-mm-dd HH:MM:ss"),
      };

      otlist.push(r);
    }
    return otlist;
  }

  formInitilization(id) {
    this.driverConcernForm = this.formBuilder.group({
      id: [id],
      comments_des: ["", Validators.required],
      comments_status: ["", [Validators.required, Validators.min(1)]],
      sl_date: [{ value: "", disabled: true }],
    });
  }

  openStatus(driverConcern) {
    console.log("openstatus", driverConcern);
    this.driverMainModalBox = driverConcern.comments;
  }

  openFeedBackStatus(value) {
    this.driverFeedBackBox = [];
    this.driverFeedBackBox.push(value);
    console.log("this.driverFeedBackBox", this.driverFeedBackBox);
  }

  onSubmit() {
    if (this.driverConcernForm.invalid) {
      return;
    }
    var sla = "0";
    if (this.driverConcernForm.value.comments_status == "ACKNOWLEDGED") {
      sla = AppConstants.REQUEST_SLA.DRIVER_CONCERN;
    }
    var newcomments = {
      // date: this.carRequestFm.value.comments_date, // yyyy-mm-dd
      date: new Date().toISOString(),
      des: this.driverConcernForm.value.comments_des,
      status: this.driverConcernForm.value.comments_status,
      exdata: sla,
    };

    var driverConcernStat = {
      id: this.displayConcernItem.id,
      comments: this.displayConcernItem.comments.length === 0
        ? [newcomments]
        : [...this.displayConcernItem.comments, newcomments],
      request_status: this.driverConcernForm.value.comments_status,
      sla_date:
        this.slaNextWorkingDay == ""
          ? this.displayConcernItem.sla_date
          : this.slaNextWorkingDay,
      updated_date: new Date().toISOString(),
    };

    const pushNotificationConfirmObject = {
      comments: this.driverConcernForm.value.comments_des,
      status: this.driverConcernForm.value.comments_status,
    };

    this.aws
      .updateDriverConcernStat(driverConcernStat)
      .then((res) => {

        this.capSmsMail.sendMailandSMS(res, RequestType.DRIVER_CONCERN);

        this.constructPushNotification(res, pushNotificationConfirmObject);
        
        this.backButtonAction();
      })
      .catch((err) => {
        console.error("updateDriverConcernStat", err);
        alert("Sorry! Something went wrong. Try again");
      });
  }

  fromEntries(entries: [string, any][]): { [key: string]: any } {
    const obj: { [key: string]: any } = {};
    for (const [key, value] of entries) {
      obj[key] = value;
    }
    return obj;
  }
  backButtonAction() {
    this.driverDetails = {};
    this.userDetails = {};
    this.displayConcernValue = 0;
    this.getDriverConcernList();
  }

  // onStatusChange() {
  //   if (this.driverConcernForm.value.comments_status == "ACKNOWLEDGED") {
  //     this.slaNextWorkingDay = this.dateUtil.getNextWorkingDayFrom(3);
  //   }
  // }

  constructPushNotification(param, bodyMsg) {
    console.log("::param", param.username);
    var rn = "RN55555";
    // Notification Title
    // Notification Content
    // Notification URL
    // Notification Icon
    // Browser Icon
    // Notification image

    this.pushNotificationService.listApplicationServices(param.username).then(
      (items) => {
        console.log("APP-SERVICE-LIST-SUCCESS", items);
        var status = param.request_status.toUpperCase().replace(/[_-]/g, " ");
        var pushObj: pushNotification = {
          token: items.fcm_token,
          notification: {
            title: "RNConnect - Cap Assits ",
            body:
              `Driver Concerns - Your request id  ${param.request_id} ` +
              " status is " +
              status,
          },
          android: {
            notification: {
              click_action: "FCM_PLUGIN_ACTIVITY",
            },
          },
          apns: {
            headers: {
              "apns-priority": "5",
            },
            payload: {
              aps: {
                category: "NEW_MESSAGE_CATEGORY",
              },
            },
          },
          data: {
            icon: "ic_launcher",
            navigationTo: "ca-notification",
            content: bodyMsg.comments,
            did: param.driver_id,
            cp_header: "driverConcern",
            request_id: param.request_id
          },
        };
        this.capSmsMail.pushNotificationFCM(pushObj);
      },
      (error) => {
        // Some task on failure
        console.log("APP-SERVICE-LIST-ERROR", error);
      }
    );
  }

  valuechange(paramDate: any) {
    console.log("SELECTED-DATE", paramDate);
    let date_1 = new Date(paramDate);
    let date_2 = new Date();

    const days = (date_1, date_2) => {
      let difference = date_1.getTime() - date_2.getTime();
      let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
      return TotalDays;
    };

    this.setDateToGo = days(date_1, date_2);
    // var day = new Date();
    // day = new Date(formatDate(day, "yyyy-MM-dd", "en"));
    // if (date.getDay() === 0 || date.getDay() === 6) {

    // }

    var day = new Date(paramDate).getUTCDay();
    if ([6, 0].includes(day)) {
      this.driverConcernForm.controls.sl_date.setErrors({
        invalidNumber: true,
      });
    } else {
      this.driverConcernForm.controls.sl_date.setErrors(null);
      this.slaNextWorkingDay = paramDate; //this.dateUtil.getNextWorkingDayFrom(paramDate);
    }

    // this.slaNextWorkingDay = this.dateUtil.getNextWorkingDayFrom(
    //   this.setDateToGo
    // );
    console.log(this.setDateToGo + " days to");
  }

  onStatusChange() {
    if (
      this.driverConcernForm.value.comments_status == "ACKNOWLEDGED" ||
      this.driverConcernForm.value.comments_status == "IN_PROGRESS"
    ) {
      this.driverConcernForm.get("sl_date").enable();
    } else {
      this.driverConcernForm.get("sl_date").disable();
    }
  }
}
